import Message from "../../shared/Message.jsx";
import "./Contact.css";

export default function Contact() {
  return (
    <div className="contact">
      <h1 className="big-title">Contact Me</h1>
      <Message></Message>
    </div>
  );
}
